
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/course/[coursePath]/lecture/[lectureId]",
      function () {
        return require("private-next-pages/school/course/[coursePath]/lecture/[lectureId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/course/[coursePath]/lecture/[lectureId]"])
      });
    }
  